import jwtDecode from "jwt-decode";
import type { SourceDecodedToken } from "../Types/SourceTypes";

const normalizeEnvironment = (value?: string | null): string =>
  (value ?? "").trim().toLowerCase();

const getEnvironmentFromApiBaseUrl = (): string => {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL?.trim();

  if (!apiBaseUrl) {
    return "";
  }

  const normalizedUrl = normalizeEnvironment(apiBaseUrl);
  if (normalizedUrl.includes("demo")) {
    return "demo";
  }
  if (normalizedUrl.includes("dev")) {
    return "dev";
  }

  return "";
};

export const getTokenEnvironment = (token: SourceDecodedToken): string | undefined =>
  token.environment_id ?? token.environment ?? token.env_id ?? token.env;

export const getEnvironmentId = (
  token: string | null,
  params: URLSearchParams
): string => {
  const apiBaseEnvironment = getEnvironmentFromApiBaseUrl();
  if (apiBaseEnvironment) {
    return apiBaseEnvironment;
  }

  const queryEnvironment =
    params.get("environment_id") ??
    params.get("environmentId") ??
    params.get("environment") ??
    params.get("env_id") ??
    params.get("env");

  if (queryEnvironment) {
    return normalizeEnvironment(queryEnvironment);
  }

  if (token) {
    try {
      const tokenEnvironment = getTokenEnvironment(jwtDecode<SourceDecodedToken>(token));

      if (tokenEnvironment) {
        return normalizeEnvironment(tokenEnvironment);
      }
    } catch {}
  }

  const storedEnvironment =
    localStorage.getItem("environment_id") ??
    localStorage.getItem("environmentId") ??
    localStorage.getItem("environment") ??
    localStorage.getItem("env_id") ??
    localStorage.getItem("env");

  if (storedEnvironment) {
    return normalizeEnvironment(storedEnvironment);
  }

  const hostname = window.location.hostname.toLowerCase();
  if (hostname.includes("demo")) {
    return "demo";
  }
  if (hostname.includes("dev")) {
    return "dev";
  }

  return "";
};
